import React, { useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../../firebase/firebaseConfig";

const ContactForm = () => {
  const [forms, setForms] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const [, forceUpdate] = useState();
  const validator = new SimpleReactValidator({
    className: "errorMessage",
    autoForceUpdate: { forceUpdate: () => forceUpdate({}) },
  });

  const changeHandler = (e) => {
    setForms((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

    validator.showMessageFor(e.target.name);
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!validator.allValid()) {
      validator.showMessages();
      forceUpdate({});
      return;
    }

    try {
      const functions = getFunctions(app);
      const sendContactEmail = httpsCallable(functions, "sendContactEmail");

      // 🔥 SAFE snapshot before reset
      const dataToSend = { ...forms };

      console.log("FINAL DATA SENT TO FIREBASE:", dataToSend);

      await sendContactEmail(dataToSend);

      // RESET AFTER SUCCESS
      setForms({
        name: "",
        email: "",
        subject: "",
        phone: "",
        message: "",
      });

      alert("Message sent successfully!");
    } catch (error) {
      console.error("Error sending contact form:", error);
      alert("There was an error sending your message.");
    }
  };

  return (
    <form onSubmit={submitHandler} className="contact-form-modern">
      <div className="row">
        <div className="col-lg-6 col-12">
          <div className="form-floating-field">
            <input
              type="text"
              name="name"
              value={forms.name}
              onChange={changeHandler}
              required
            />
            <label>Your Name</label>
          </div>
        </div>

        <div className="col-lg-6 col-12">
          <div className="form-floating-field">
            <input
              type="email"
              name="email"
              value={forms.email}
              onChange={changeHandler}
              required
            />
            <label>Your Email</label>
          </div>
        </div>

        <div className="col-lg-6 col-12">
          <div className="form-floating-field">
            <input
              type="tel"
              name="phone"
              value={forms.phone}
              onChange={changeHandler}
              required
            />
            <label>Your Phone</label>
          </div>
        </div>

        <div className="col-lg-6 col-12">
          <div className="form-floating-field">
            <select
              name="subject"
              value={forms.subject}
              onChange={changeHandler}
              required
            >
              <option value="">Choose a Service</option>
              <option value="Management Proposal">Management Proposal</option>
              <option value="Financial Services">Financial Services</option>
              <option value="Community Support">Community Support</option>
              <option value="Developer Services">Developer Services</option>
            </select>
            <label>Topic</label>
          </div>
        </div>

        <div className="col-12">
          <div className="form-floating-field">
            <textarea
              name="message"
              value={forms.message}
              onChange={changeHandler}
              required
            ></textarea>
            <label>Message</label>
          </div>
        </div>
      </div>

      <button type="submit" className="service-btn">
        Send Message
      </button>
    </form>
  );
};

export default ContactForm;
